/**
 * Blocks API
 *
 * Functions for blocking and unblocking users.
 * Issue #920: Add UI for message deletion, user blocking, and reporting
 */

import { apiGet, apiPost, apiDelete } from '../api';

export interface BlockedUser {
  id: string;
  first_name: string | null;
  last_name: string | null;
  profile_image_url: string | null;
  blocked_at: number;
}

export interface BlockResponse {
  block: {
    id: string;
    blocker_id: string;
    blocked_id: string;
    created_at: number | null;
  };
  already_blocked?: boolean;
}

export interface BlockedUsersResponse {
  blocked_users: BlockedUser[];
}

export const blocksApi = {
  /**
   * Block a user
   * POST /blocks
   */
  blockUser: (blockedId: string): Promise<BlockResponse> => {
    return apiPost<BlockResponse>('/blocks', { blocked_id: blockedId });
  },

  /**
   * Unblock a user
   * DELETE /blocks/:blockedUserId
   */
  unblockUser: (blockedUserId: string): Promise<void> => {
    return apiDelete<void>(`/blocks/${blockedUserId}`);
  },

  /**
   * Get list of blocked users
   * GET /blocks
   */
  getBlockedUsers: (): Promise<BlockedUsersResponse> => {
    return apiGet<BlockedUsersResponse>('/blocks');
  },
};
